// removed by extract-text-webpack-plugin
module.exports = {"featureSelect":"qempo_FeatureSelect_featureSelect-kWoT8B5","active":"qempo_FeatureSelect_active-rXhi2gi"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/custom-products/components/FeatureSelect/FeatureSelect.scss
// module id = 207
// module chunks = 0